// extracted by mini-css-extract-plugin
module.exports = {"slide":"TagManagment_slide_2ZaGR","slide-reverse":"TagManagment_slide-reverse__ucT3","alert":"TagManagment_alert_3IvYQ","list":"TagManagment_list_1Pr6E"};